import React from 'react';
import Anchor from '@/common/Anchor';
import { useGetVehicleId } from '~/context/vdp/VehicleContext';

type OwnProps = React.HTMLAttributes<HTMLAnchorElement> &
  React.PropsWithChildren<{
    'data-analytics-id': string;
  }>;

export default function AutoCheckLink({
  children,
  'data-analytics-id': dataAnalyticsId,
  ...props
}: OwnProps) {
  const vehicleId = useGetVehicleId();

  return (
    <Anchor
      href={`/vehicle/autocheck/${vehicleId}`}
      target="_blank"
      rel="noopener noreferrer"
      data-analytics-id={dataAnalyticsId}
      {...props}
    >
      {children}
    </Anchor>
  );
}
